<script>
import GiftApi from "@/services/gift-api";



export default {  

  props: {
          firstDay:{
              type:String,
              default:null
          },
          lastDay:{
              type:String,
              default:null
          },
          campaignId:{
              type:Number,
              default:null
          }
      },

  data() {
    return {
      
        start:null,
        end:null,

        pagemodel: { currentPage: 1, perPage: 10, totalRows: 0 },
        giftWinnerList: null,
        isTableLoading: false,
        giftWinnerFields: [
                {key: "timeStamp",label: "Date",thClass: "",tdClass: " align-middle",thStyle: "", tdStyle: "",},
                {key: "giftId",label: "Id Cadeaux",thClass: "text-left",tdClass: "text-left align-middle",},
                {key: "giftName",label: "Cadeaux",thClass: "text-left",tdClass: "text-left align-middle",},
                {key: "name",label: "Client",thClass: "text-left",tdClass: "text-left align-middle",},
                {key: "phone",label: "Télephone",thClass: "text-left",tdClass: "text-left align-middle",},
                {key: "email",label: "Email",thClass: "text-left",tdClass: "text-left align-middle",},
            ],
    }

  },
  mounted(){

    if(this.campaignId){
      this.getAllGiftWinner();
    }


  },
  watch:{
    start : function(){
        this.getAllGiftWinner()
    },
    
    end : function(){
        this.getAllGiftWinner()
    },

    campaignId: function(){
      this.getAllGiftWinner();
    }


  },

  methods:{


    getAllGiftWinner() {

    if(!this.campaignId){
      return
    }

    this.isTableLoading = true;

     GiftApi.getAllGiftWinner( this.pagemodel.currentPage, this.pagemodel.perPage, this.start, this.end, this.campaignId)
        .then((giftWinnerList) => {
        if (giftWinnerList) {
            this.giftWinnerList = giftWinnerList.list;
            this.pagemodel.totalRows = giftWinnerList.total;
            this.pagemodel.currentPage = giftWinnerList.page;
            this.pagemodel.perPage = giftWinnerList.pageSize;
            this.pagemodel.pageSize = giftWinnerList.pageSize;
        }
        })
        .finally(() => {
        this.isTableLoading = false;
        });
    },
  }

};
</script>
<template>
        <div  class="card mt-md-5 mt-2 p-md-0 p-3 ">
          <div class="card-body">
            <div class="row">
                <div class="col-md-6 col-sm-12"> 
                    <h4 class="text-dark text-uppercase font-weight-bold" style="font-size:25px;">{{$t('gift.giftWinnerTitle')}} </h4>
                </div>

            <div class="col-6 col-sm-6 col-md-3 pr-2  text-center " >
                    <b-form-group   label-for="">
                    <b-form-datepicker
                    v-model="start"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button size="sm"
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright
                    hide-header
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                    </b-form-group>
            </div>

            <div class="col-6 col-sm-6 col-md-3 pl-2  text-center " >

                
                    <b-form-group label-for="">
                    <b-form-datepicker
                    v-model="end"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright                         
                    hide-header size="sm"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                </b-form-group>
            </div>


            </div>

          <div class="table-responsive" style="min-height: 27em;">
            <b-table
                :busy="isTableLoading"
                :striped="true"
                :small="false"
                :hover="true"
                :items="giftWinnerList"
                :fields="giftWinnerFields"
                :perPage="pagemodel.perPage"
                class="table mt-3"
                style="min-width:1000px ;"
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>

                <template v-slot:cell(email)="{ value }">
                    {{value ? value  : '-' }}
                </template>

                <template v-slot:cell(phone)="{ value }">
                    {{value ? value  : '-' }}
                </template>


                <template v-slot:cell(name)="{ value }">
                    {{value ? value  : '-' }}
                </template>


                <template v-slot:cell(isValid)="{ value }">
                    <div :class="['d-inline-block', 'rounded-circle', 'border', 'border-2', 'shadow', value ? 'bg-success' : 'bg-danger']" 
                        style="width: 20px; height: 20px;">
                    </div>
                </template>



            </b-table>

            <span v-if="!isTableLoading && giftWinnerList && !giftWinnerList.length" class="d-flex justify-content-center m-4 text-secondary">
             {{ $t("gift.emptyWinner") }}
            </span>
          </div>
             <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getAllGiftWinner()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getAllGiftWinner()" :disabled="isTableLoading" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  --> 

          </div>
        </div>

</template>

